import React, { useEffect, useState } from "react";
import { InputFieldWithoutForm, SelectField, TextAreaField } from "../../../form/input-fields";
import { debug } from "console";

const ManipulationValidationComponent = ({
  manipulationType,
  validationType,
  manipulationValue,
  validationValue,
  uniqueId,
  handleManipulationValidation
}: any) => {
  //#region Grid Function
  const [manipulationTypeValue, setManipulationTypeValue] = useState(manipulationType);
  const [regexValue, setRegexValue] = useState("");
  const [validationRegexValue, setValidationRegexValue] = useState("");
  const [validationTypeValue, setValidationTypeValue] = useState(validationType);
  const [minValue, setMinValue] = useState("");
  const [maxValue, setMaxValue] = useState("");

  const getGridValidationData = (type: any, idValue: any, value: any) => {
    let validationValue = null;
    if(type === 1){
      validationValue = [{"type": type,"result": value}]
    }else if(type === 2){
      let validationMinMaxValue = "";
      if(idValue === "min"){
        validationMinMaxValue =  JSON.stringify({ type: type, min: value, max: maxValue });
      }else{
        validationMinMaxValue =  JSON.stringify({ type: type, min: minValue, max: value });
      }
      validationValue = [{"type": type,"result": validationMinMaxValue}]
    }
    return validationValue;
  };

  const getGridManipulationData = (type: any, value: any) => {
    let manipulationValue = null;
    if(type >= 2 && type <= 7){
      manipulationValue = [{"type": type,"result": value}]
    }
    return manipulationValue;
  };

  const manipulationDropdownChange = (value: any, idValue: any, uniqueId: any) => {
    if(idValue === "manipulationType"){
      setManipulationTypeValue(parseInt(value));
    } else if(idValue === "validationType"){
      setValidationTypeValue(value);
    }
  };
  
  const handleManipulationValidationChange = (value: any, idValue: any, uniqueId: any, typeValue: any) => {
    if(idValue === "manipulationResult"){
      setRegexValue(value);
      const manipulationData = getGridManipulationData(typeValue, value);
      handleManipulationValidation(manipulationData, idValue, uniqueId, typeValue);
    }
    else if(idValue === "validationResult"){
      setValidationRegexValue(value);
      const validationData = getGridValidationData(typeValue, idValue, value);
      handleManipulationValidation(validationData, idValue, uniqueId, typeValue);
    }
    else if (idValue === "min") {
      setMinValue(value);
      if (maxValue && parseInt(value, 10) > parseInt(maxValue, 10)) {
        return;
      }
    } else if (idValue === "max") {
      setMaxValue(value);
      if (minValue && parseInt(value, 10) < parseInt(minValue, 10)) {
        return;
      }
    }
    if (idValue !== "manipulationResult" && (minValue && maxValue)) { 
      const validationData = getGridValidationData(2, idValue, value);
      idValue = "validationResult";
      handleManipulationValidation(validationData, idValue, uniqueId, typeValue);
    }
  };

  const setManipulationValidationData = () => {
    if(manipulationType){
      manipulationDropdownChange(manipulationType, "manipulationType", uniqueId);
      setRegexValue(manipulationValue || "");
    }
    else{
      clearManipulationData();
    }
    if(validationType){
      if(validationType === 2){
        const parsedValidationValue = JSON.parse(validationValue || "{}"); // Parse safely with fallback to an empty object
        const { min, max } = parsedValidationValue;
        if (min && max) {
          setMinValue(min);
          setMaxValue(max);
          manipulationDropdownChange(validationType, "validationType", uniqueId);
        } else {
          console.warn("Min or Max value not found in validationValue");
        }
      }
    }
    else{
      clearValidationData();
    }
  };

  const clearManipulationData = () => {
    setManipulationTypeValue("");
    setRegexValue("");
  };
  
  const clearValidationData = () => {
    setValidationTypeValue("");
    setMinValue("");
    setMaxValue("");
  };
  
  useEffect(()=>{
    if(uniqueId){
      setManipulationValidationData();
    }
  }, [uniqueId])

  return (
    <div className="grid grid-cols-1 gap-4 mb-4 p-3 m-10 bg-white rounded-lg dark:bg-[#272936]">
      {/*Manipulation Data Section*/}
      <div className="manipulation-section mt-6 p-4 bg-gray-100 dark:bg-[#1f2028] rounded-lg">
        <h3 className="text-[2.2rem] font-semibold mb-7">Manipulation Data</h3>
        <div className="mb-7">
          <SelectField
            labelName={"Type"}
            options={[
              { label: "Global Regex", value: "1" },
              { label: "Regex", value: "2" },
              { label: "Levenshtein", value: "3" },
              { label: "Shift Replace", value: "4" },
              { label: "Text to Number", value: "6" },
              { label: "Text to Date", value: "7" },
            ]}
            id="manipulationType"
            isRequired={true}
            value={manipulationTypeValue}
            error={""}
            onChange={(value) => manipulationDropdownChange(value, "manipulationType", uniqueId)}
          />
        </div>
        {(manipulationTypeValue >= 2 || manipulationTypeValue <= 7) && (
          <div className="mt-4">
            <TextAreaField
              labelName={"Regex"}
              id={"regex"}
              isRequired={true}
              value={regexValue}
              onChange={(value) => handleManipulationValidationChange(value, "manipulationResult", uniqueId,manipulationTypeValue)}
            />
          </div>
        )}
      </div>

      {/* Validations Data Section */}
      <div className="validation-section mt-6 p-4 bg-gray-100 dark:bg-[#1f2028] rounded-lg">
        <h3 className="text-[2.2rem] font-semibold mb-7">Validations Data</h3>
        <div className="mb-7">
          <SelectField
            labelName={"Type"}
            options={[
              { label: "Regex", value: "1" },
              { label: "Min & Max", value: "2" },
            ]}
            id="dataType"
            isRequired={true}
            value={validationTypeValue}
            error={""}
            onChange={(value) => manipulationDropdownChange(value, "validationType", uniqueId)}
          />          
        </div>
        {(validationTypeValue === "1" || validationTypeValue === 1) && (
          <div className="mt-4">
            <TextAreaField
              labelName={"Regex"}
              id={"validationRegex"}
              isRequired={true}
              value={validationRegexValue}
              onChange={(value) => handleManipulationValidationChange(value, "validationResult", uniqueId,manipulationTypeValue)}
            />
          </div>
        )}
        {(validationTypeValue === "2" || validationTypeValue === 2) && (
          <div className="grid grid-cols-2 gap-4">
            <div>
              <InputFieldWithoutForm
                labelName={"Min"}
                type="number"
                id={"min"}
                isRequired={true}
                value={minValue}
                error={""}
                onChange={(value) => handleManipulationValidationChange(value, "min", uniqueId, validationTypeValue)}
              />
            </div>
            <div>
              <InputFieldWithoutForm
                labelName={"Max"}
                type="number"
                id={"max"}
                isRequired={true}
                value={maxValue}
                error={""}
                onChange={(value) => handleManipulationValidationChange(value, "max", uniqueId, validationTypeValue)}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ManipulationValidationComponent;
